import { SystemCode } from '@/api'

export interface ReserveUpdateRequest {
  id: number
  reserveMethod: string
  reserveSpecifyBranch: SystemCode[]
  specifyCollectionId: number
  specifyCollectionNo: string
  reserveRegistrationBranchCode: SystemCode
  reserveRegistrationPlaceCode: SystemCode
  forwardingBranchCode: SystemCode
  forwardingPlaceCode: SystemCode
  reserveRegistrationDate: string
  preferredDate: string
  reserveExpiration: string
  reserveNoticeAllowed: boolean
  contactMethod: SystemCode
  displayMemo: string
}

export function ReserveUpdateRequestToJSON(value: ReserveUpdateRequest): any {
  return {
    id: value.id,
    reserve_method: value.reserveMethod,
    reserve_specify_branch_codes:
      value.reserveSpecifyBranch.length > 0
        ? value.reserveSpecifyBranch.map(item => item.code)
        : undefined,
    specify_collection_id:
      value.specifyCollectionId !== 0 ? value.specifyCollectionId : undefined,
    specify_collection_no:
      value.specifyCollectionNo !== '' ? value.specifyCollectionNo : undefined,
    reserve_registration_branch_code: value.reserveRegistrationBranchCode.code,
    reserve_registration_place_code: value.reserveRegistrationPlaceCode.code,
    forwarding_branch_code: value.forwardingBranchCode.code,
    forwarding_place_code: value.forwardingPlaceCode.code,
    reserve_registration_date: value.reserveRegistrationDate,
    preferred_date: value.preferredDate,
    reserve_expiration: value.reserveExpiration,
    reserve_notice_allowed: value.reserveNoticeAllowed,
    contact_method: value.contactMethod.code,
    display_memo: value.displayMemo
  }
}
